export const isPhone = (contact) => {
  return /^(\+\d{1,4})?\d{7,11}$/.test(contact)
}

export const isEmail = (contact) => {
  return /^[^@]+@[^@.]+\.[^@.]{1}[^@]*$/.test(contact)
}
